/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { connect } from 'react-redux';
import {
  Grid, Form, Select, Badge, Formatter, Tabs, EventoServer,
} from '@cgn/framework-ui-components/v1';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import Actions from './Actions';
import Enums from '../Shared/Enums';
import WrapperQuesito from './Quesito/WrapperQuesito';
import NessunQuesito from './NessunQuesito';
import { getQueryParams } from '../Shared/Utils';
import { withEventiServer } from '../Shared/EventiServer/EventiServerContext';
import { messaggiServerEnum } from '../Exports/iframeComunication';

const { Row } = Grid;
const { Col } = Grid;

class ListaQuesiti extends React.Component {
  state = {
    messaggi: [],
    servizio: null,
    ricerca: null,
    anniDisponibili: [],
    annoSelezionato: null,
    tutti: true,
    quesitoCorrente: null,
  };

  getChildContext() {
    return {
      segnaPraticaComeLetta: (idPratica) => this.segnaPraticaComeLetta(idPratica),
      caricaQuesiti: (statoMessaggio, ufficioSelezionato, testo, navigaA, nuovaRisposta) => this.caricaQuesiti(statoMessaggio, ufficioSelezionato, testo, navigaA, nuovaRisposta),
      quesitoSelezionato: (idQuesito) => {
        const { quesitoCorrente } = this.state;
        if (idQuesito != quesitoCorrente) {
          this.setState({ quesitoCorrente: idQuesito });
        }
      },
    };
  }

  componentDidMount() {
    const { eventiServerContext } = this.props;

    const ufficioSelezionato = getQueryParams(this.props.location.search).ufficio;
    if (ufficioSelezionato) {
      this.props.impostaUfficioSelezionato(ufficioSelezionato);
    }
    this.caricaQuesiti(
      this.props.match.params.stato,
      ufficioSelezionato || this.props.ufficioSelezionato,
      this.props.match.params.testo,
      true,
      this.props.match.params.idQuesito,
    );

    const refreshCallback = () => this.caricaQuesiti(this.props.match.params.stato, this.props.ufficioSelezionato, this.props.match.params.testo, false, true);
    this.eventiServerSubscriptions = [
      eventiServerContext.subscribe(messaggiServerEnum.RispostaInviata, refreshCallback),
      eventiServerContext.subscribe(messaggiServerEnum.PrerispostaInviata, refreshCallback),
      eventiServerContext.subscribe(messaggiServerEnum.PraticaChiusa, refreshCallback),
      eventiServerContext.subscribe(messaggiServerEnum.PraticaPresaInCarico, refreshCallback),
      eventiServerContext.subscribe(
        messaggiServerEnum.NuovoQuesito,
        () => this.caricaQuesiti(Enums.Quesiti.toString(Enums.Quesiti.Aperti), this.props.ufficioSelezionato, this.props.match.params.testo, false),
      ),
    ];
  }

  UNSAFE_componentWillReceiveProps(next) {
    const ufficioSelezionato = getQueryParams(next.location.search).ufficio;
    if (ufficioSelezionato && getQueryParams(this.props.location.search).ufficio != ufficioSelezionato) {
      this.props.impostaUfficioSelezionato(ufficioSelezionato);
    }

    if ((this.props.match.params.stato != next.match.params.stato || this.props.match.params.testo != next.match.params.testo) || this.props.ufficioSelezionato != next.ufficioSelezionato) {
      this.caricaQuesiti(next.match.params.stato, next.ufficioSelezionato, next.match.params.testo, true);
    }
  }

  componentWillUnmount() {
    this.eventiServerSubscriptions.forEach((unsubscribeFunc) => { unsubscribeFunc(); });
  }

  caricaQuesiti = (statoMessaggio, ufficioSelezionato, testo, navigaA, id) => {
    if (this.loading) {
      return;
    }

    this.loading = true;

    if (statoMessaggio == 'aperti') {
      Actions.tutteLePratiche(ufficioSelezionato).then((res) => {
        this.loading = false;
        this.context.impostaQuesiti(res);

        const aperti = res.filter((x) => x.Aperta && x.Storicizzata == false);
        this.setState({ messaggi: aperti, servizio: null });

        if (navigaA) {
          const idPratica = id || (aperti[0] ? aperti[0].IdPratica : '');
          this.props.history.push(`/messaggi/quesiti/aperti/quesito/${idPratica}`);
        }
      });
    } else if (statoMessaggio == 'chiusi') {
      Actions.tutteLePratiche(ufficioSelezionato).then((res) => {
        this.loading = false;
        this.context.impostaQuesiti(res);

        const chiusi = res.filter((x) => !x.Aperta);
        this.setState({ messaggi: chiusi, servizio: null });

        if (navigaA) {
          const idPratica = id || (chiusi[0] ? chiusi[0].IdPratica : '');
          this.props.history.push(`/messaggi/quesiti/chiusi/quesito/${idPratica}`);
        }
      });
    } else if (statoMessaggio == 'archiviati') {
      Actions.tutteLePratiche(ufficioSelezionato).then((res) => {
        this.loading = false;
        this.context.impostaQuesiti(res);
      });

      Actions.anniPratiche(ufficioSelezionato).then((anni) => Actions.archivio(ufficioSelezionato, this.state.annoSelezionato || anni.sort((a, b) => b - a).filter((x, i) => i > 0)[0]).then((res) => {
        this.setState({
          messaggi: res, anniDisponibili: anni.sort((a, b) => b - a).filter((x, i) => i > 0), annoSelezionato: this.state.annoSelezionato || anni.sort((a, b) => b - a).filter((x, i) => i > 0)[0], servizio: null,
        });
        const idPratica = id || (res[0] ? res[0].IdPratica : '');
        this.props.history.push(`/messaggi/quesiti/archiviati/quesito/${idPratica}`);
      }));
    } else {
      // sono in ricerca
      Actions.ricerca(ufficioSelezionato, testo).then((res) => {
        this.setState({ messaggi: res, servizio: null });
        if (res[0] && this.props.match.params.idQuesito == null) {
          this.props.history.push(`/messaggi/quesiti/ricerca/${testo}/quesito/${res[0] ? res[0].IdPratica : ''}`);
        }
      });

      Actions.tutteLePratiche(ufficioSelezionato).then((res) => {
        this.loading = false;
        this.context.impostaQuesiti(res);
      });
    }
  };

  caricaAnno = (anno) => {
    Actions.archivio(this.props.ufficioSelezionato, anno).then((res) => {
      this.setState({ messaggi: res, annoSelezionato: anno, servizio: null });
      this.props.history.push(`/messaggi/quesiti/archiviati/quesito/${res[0].IdPratica}`);
    });
  };

  vaiAQuesito = (pratica) => {
    if (this.props.match.params.testo) {
      this.props.history.push(`/messaggi/quesiti/ricerca/${this.props.match.params.testo}/quesito/${pratica.IdPratica}`);
    } else {
      this.props.history.push(`/messaggi/quesiti/${this.props.match.params.stato}/quesito/${pratica.IdPratica}`);
    }
  };

  segnaPraticaComeLetta = (idPratica, nonRicaricare) => {
    Actions.leggiConversazione(idPratica).then((res) => {
      if (!nonRicaricare) {
        this.caricaQuesiti(this.props.match.params.stato, this.props.ufficioSelezionato, this.props.match.params.testo, false);
      }
    });
  };

  impostaLettura = (indice) => {
    this.setState({ tutti: indice == 0 });
  };

  render() {
    const { quesitoCorrente } = this.state;
    return (
      <Row>
        <Col xs={12} md={4}>
          <div className="quesiti__col">
            <div className="quesiti__filtroServizi">
              <Form onChange={(x) => this.setState(x)} stato={this.state}>
                {this.props.match.params.stato == 'archiviati' && (
                  <Select name="annoSelezionato" title="Anno: " onChange={(e) => this.caricaAnno(e.target.value)}>
                    {this.state.anniDisponibili.map((x, i) => (
                      <Select.Option value={x} key={i}>
                        {x}
                      </Select.Option>
                    ))}
                  </Select>
                )}

                {this.props.match.params.stato != 'archiviati' && (
                  <Select name="servizio" title="Filtra per">
                    <Select.Option value={null}>Tutti i servizi</Select.Option>
                    {this.state.messaggi.map((x) => x.Servizio).filter((x, i, s) => s.indexOf(x) == i).map((x, i) => (
                      <Select.Option value={x} key={i}>
                        {x}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form>

              <Tabs initialIndex={0} onSelect={this.impostaLettura}>
                <Tabs.Tab title="Tutti" />
                <Tabs.Tab title="Solo i miei" />
              </Tabs>
            </div>
            <ul className="quesiti__listaPratiche lista">
              {this.state.messaggi.filter((x) => (this.state.servizio == null ? true : x.Servizio == this.state.servizio))
                .filter((x) => (this.state.tutti ? true : x.IdUtenteFederato == this.props.profilo.AccountId))
                .map((x, i) => {
                  const classes = classNames('questiti__quesito', { selezionato: x.IdPratica == quesitoCorrente });
                  return (
                    <li className={classes} key={i} onClick={() => this.vaiAQuesito(x)}>
                      {x.LettaDaUtente == false && <Badge alarm className="quesiti__badgeNotifica">&nbsp;&nbsp;</Badge>}
                      <div className="quesiti__pratica">
                        <span className="quesiti__listaPraticheTitolo">{x.LettaDaUtente ? <span dangerouslySetInnerHTML={{ __html: x.Titolo }} /> : <strong dangerouslySetInnerHTML={{ __html: x.Titolo }} />}</span>
                        <span className="quesiti__listaPraticheServizio">{x.Servizio}</span>
                        <span className="quesiti__listaPraticheData"><Formatter valore={x.DataUltimoMessaggio} tipo="date" /> <Formatter valore={x.DataUltimoMessaggio} tipo="hour" /> - </span>Stato <span><strong>{Enums.StatoPratica.toString(x.StatoAttuale || x.Stato).toLowerCase()}</strong></span>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
        </Col>
        <Col xs={12} md={8}>
          <div className="quesiti__col quesiti__conversazione">
            {
              !this.props.match.params.stato
              && <Route path={`${this.props.match.path}/quesito/:idQuesito`} component={WrapperQuesito} />
            }
            {
              this.props.match.params.stato && (
                <React.Fragment>
                  <Route exact path={`${this.props.match.path}/quesito`} component={NessunQuesito} />
                  <Route path={`${this.props.match.path}/quesito/:idQuesito`} component={WrapperQuesito} />
                </React.Fragment>
              )
            }
          </div>

        </Col>
      </Row>
    );
  }
}

ListaQuesiti.contextTypes = {
  router: PropTypes.object,
  impostaQuesiti: PropTypes.func,
  verificaQuesitiNonLetti: PropTypes.func,
};

ListaQuesiti.childContextTypes = {
  segnaPraticaComeLetta: PropTypes.func,
  caricaQuesiti: PropTypes.func,
  quesitoSelezionato: PropTypes.func,
};

const mapStateToProps = (state) => ({ ufficioSelezionato: state.ufficioSelezionato, profilo: state.profilo });

const mapDispatchToProps = (dispatch) => ({
  impostaUfficioSelezionato: (ufficioSelezionato) => {
    window.modificaUfficioCorrenteMenuHome && window.modificaUfficioCorrenteMenuHome(ufficioSelezionato);
    dispatch({ type: 'IMPOSTA_UFFICIO_SELEZIONATO', ufficioSelezionato });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withEventiServer(ListaQuesiti));
